import React from 'react';
import classNames from 'classnames';
import classes from '@nerdwallet/base-styles/classes';

const CompanyStroke = () => (
  <div
    className={classNames([
      'company__stroke',
      classes('border-bottom-1'),
      classes('border-neutral-lighter'),
      classes('margin-horizontal-3'),
      classes('margin-horizontal-auto--wide'),
      classes('margin-top-4'),
      classes('margin-bottom-5'),
    ])}
  >
    &nbsp;
  </div>
);

CompanyStroke.displayName = 'CompanyStroke';

export default CompanyStroke;
